import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { View } from "./view";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logoAffinity.svg";
import { UseUserConfirmPassword } from "../../fnx/user/userConfirmPassword";
import { position, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
export var ConfirmPasswordReset = function () {
    var navigate = useNavigate();
    var _a = useState(false), trigger = _a[0], setTrigger = _a[1];
    var _b = useState({}), bodyRequest = _b[0], setBodyRequest = _b[1];
    var _c = UseUserConfirmPassword(trigger, bodyRequest), responseConfirmPassword = _c.responseConfirmPassword, errorConfirmPassword = _c.errorConfirmPassword, loadingConfirmPassword = _c.loadingConfirmPassword;
    var _d = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _d[0], setSeeToast = _d[1];
    useEffect(function () {
        if (responseConfirmPassword && (responseConfirmPassword === null || responseConfirmPassword === void 0 ? void 0 : responseConfirmPassword.length) > 0) {
            navigate("/login");
            setTrigger(false);
        }
    }, [responseConfirmPassword]);
    useEffect(function () {
        var _a, _b, _c;
        if (errorConfirmPassword) {
            var error = errorConfirmPassword;
            var message = "Error al reestablecer contraseña";
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.errors) !== undefined) {
                message = (_b = error.response) === null || _b === void 0 ? void 0 : _b.errors[0].message;
            }
            else {
                message = (_c = error.response) === null || _c === void 0 ? void 0 : _c.message;
            }
            setSeeToast({
                show: true,
                message: message,
                type: typeAlert.error,
            });
            setTrigger(false);
        }
    }, [errorConfirmPassword]);
    var handleSubmit = function (dataItem) {
        setBodyRequest({
            userName: dataItem.email,
            newPassword: dataItem.password,
            code: dataItem.code,
        });
        setTrigger(true);
    };
    return (_jsxs(React.Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () {
                    setSeeToast({
                        show: false,
                        message: "",
                        type: typeAlert.success,
                    });
                }), _jsx(View, { title: "Restablecer contrase\u00F1a", subTitle: "Ingrese su correo electr\u00F3nico contrase\u00F1a y el codigo de su correo electronico", emailText: "Correo electr\u00F3nico", emailPlaceHolder: "Ingresa un Usuario", logo: Logo, emailRequired: "El correo electr\u00F3nico es requerido", emailError: "Formato de correo no aceptado", emailHelperText: "Ingrese su correo electr\u00F3nico", passwordText: "Contrase\u00F1a", passwordRequired: "La contrase\u00F1a es requerida", passwordError: "La contrase\u00F1a debe tener al menos 8 caracteres", passwordHelperText: "Ingrese su contrase\u00F1a", codeText: "Codigo", codeRequired: "El codigo es requerido", codeHelperText: "Ingrese su codigo", btnColor: "#fffff", buttonText: "Restaurar contrase\u00F1a", onSaveData: handleSubmit })] }));
};
export default ConfirmPasswordReset;
